module.exports = __webpack_public_path__ + "city1.5ccf7022f41053fd8b67.jpg";


//////////////////
// WEBPACK FOOTER
// E:/sree/New folder (3)/cdk-material-v2/src/assets/images/bg/city1.jpg
// module id = ../../../../../src/assets/images/bg/city1.jpg
// module chunks = main